import { render, staticRenderFns } from "./age_pie.vue?vue&type=template&id=0e9892e5&scoped=true&"
import script from "./age_pie.vue?vue&type=script&lang=js&"
export * from "./age_pie.vue?vue&type=script&lang=js&"
import style0 from "./age_pie.vue?vue&type=style&index=0&id=0e9892e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9892e5",
  null
  
)

export default component.exports